import { useState, useEffect } from 'react'
import getFeatureStatus from '@client/services/featureStatus'

export default function useHasFork(featureName) {
  const [fork, setFork] = useState({
    isEnabled: false,
    employeesThreshold: 0,
  })

  useEffect(() => {
    async function fetchFeatureStatus() {
      try {
        const {
          data: { isEnabled, variant },
        } = await getFeatureStatus(featureName)

        setFork({
          isEnabled,
          employeesThreshold: variant?.payload?.value || 0,
        })
      } catch (error) {
        console.log('error', error)
      }
    }

    fetchFeatureStatus()
  }, [])

  return {
    fork,
  }
}
